__turbopack_context__.v({
  "content": "_2qfJra_content",
  "discountExpiryInfo": "_2qfJra_discountExpiryInfo",
  "noiseBg": "_2qfJra_noiseBg",
  "root": "_2qfJra_root",
  "subtitle": "_2qfJra_subtitle",
});
